import { TenantDto } from '../api/core';

export interface TenantState {
    loading: number;
    initiallyLoaded: boolean;
    tenants: Map<string, ExtendedTenantDto>;
}

export enum TenantActionTypes {
    LOADING = '@liebherr/tenants/loading',
    LOADING_DONE = '@liebherr/tenants/loading_done',
    LOAD_TENANTS = '@liebherr/tenants/load_tenants',
    LOADED_TENANTS = '@liebherr/tenants/loaded_tenants',
    LOAD_TENANT_DETAILS = '@liebherr/tenants/load_tenant_details',
    LOADED_TENANT_DETAILS = '@liebherr/tenants/loaded_tenant_details',
    CREATE_TENANT = '@liebherr/tenants/create_tenant',
    CREATED_TENANT = '@liebherr/tenants/created_tenant',
    UPDATE_TENANT = '@liebherr/tenants/update_tenant',
    UPDATED_TENANT = '@liebherr/tenants/updated_tenant',
    DELETE_TENANT = '@liebherr/tenants/delete_tenant',
    DELETED_TENANT = '@liebherr/tenants/deleted_tenant',
}

export const tenantFeatureKey = 'tenants';

export interface ExtendedTenantDto extends TenantDto {
    keycloakId?: string;
}
